"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const VideoItem = ({ index, video, onClick, activeVideo, available, progress, }) => {
    const { name, durationInfo, id, completed } = video;
    const active = (activeVideo === null || activeVideo === void 0 ? void 0 : activeVideo.id) === id;
    return (core_1.jsx("div", { onClick: onClick, role: "button", tabIndex: index, "aria-label": "Video Item", onKeyPress: e => {
            if (e.key === 'Enter') {
                onClick();
            }
        }, className: styles_scss_1.default.videoItem, css: styles_1.default.videoItem(active) },
        core_1.jsx("div", { className: styles_scss_1.default.videoItemLeftCont },
            core_1.jsx("img", { className: styles_scss_1.default.playIcon, src: active || completed ? constants_1.Images.playIconActive : constants_1.Images.playIcon, alt: "play icon" })),
        core_1.jsx("div", { className: styles_scss_1.default.videoItemCenterCont },
            core_1.jsx("label", { css: styles_1.default.videoItemLabel(active) }, name),
            core_1.jsx("small", { css: styles_1.default.videoItemDuration(active) }, constants_1.default.program.videoDurationInfo(durationInfo))),
        core_1.jsx("div", { className: styles_scss_1.default.videoItemRightCont }, (active && progress > 0) || (!completed && available) ? (core_1.jsx("div", null,
            core_1.jsx(components_1.ProgressIndicator, { strokeWidth: 2, width: 20, percentage: active ? progress : 0, backgroundColor: styles_scss_1.default.white }))) : (core_1.jsx("img", { css: styles_1.default.rightIcon(completed), src: completed ? constants_1.Images.check : constants_1.Images.lock, alt: completed ? "check" : "lock" })))));
};
VideoItem.defaultProps = {
    activeVideo: null,
};
exports.default = VideoItem;
